module.exports = __webpack_public_path__ + "img/David Luiz.4623a183.png";